import { Popover, PopoverProps } from "antd";
import styles from "./style.module.scss";
import { TooltipPlacement } from "antd/es/tooltip";

interface VLPopoverProps extends PopoverProps {
  content?: React.ReactNode;
  children: React.ReactNode;
  trigger?: VLPopoverTrigger;
  title?: string;
  placement?: TooltipPlacement;
  overlayClassName?: string;
}
type VLPopoverTrigger = "hover" | "click" | "focus";

export default function VLPopover({
  content,
  children,
  trigger,
  placement = "top",
  overlayClassName,
  ...rest
}: VLPopoverProps) {
  return (
    <Popover
      content={
        content ? (
          <div className={styles.popoverContent}>{content}</div>
        ) : undefined
      }
      placement={placement}
      trigger={trigger}
      color={"var(--background-surface-color-background)"}
      overlayClassName={overlayClassName}
      {...rest}
    >
      <div className={styles.popoverButton}>{children}</div>
    </Popover>
  );
}
